<app-customer-account-dialog>
  <div id="content">
    <div class="overlay filterData filterDataControls">

      <div class="overlay-header">
        <h3>Filters</h3>
        <div class="close-btn">
          <button mat-icon-button mat-dialog-close (click)="closeFilter()">
            <i class="fa-sharp fa-regular fa-xmark-large"></i>
          </button>
        </div>
      </div>
      <div class="section-divider"></div>
      <form id="filterForm" class="form-scroll">
        <div class="overlay-body">
          <div class="container">
            <div class="row">
              <div class="col-md-12">
                <h3>Date Range <span>(Max. 7 day date range) </span></h3>
              </div>
            </div>
            <div class="row border-bottom" [formGroup]="range">
              <div class="col-md-6 flex">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date From (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker1" [min]="startDate" [max]="today" formControlName="start"
                    (dateChange)="addEvent( $event)">
                  <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field appearance="fill" class="component-box">
                  <mat-label>Date To (MMM-DD-YYYY)</mat-label>
                  <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxRange" formControlName="end">
                  <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
              <!-- <p>{{range.value | json}}</p> -->
            </div>

            <div class="row">
              <div class="col-md-12">

                <h3>Client <span> (Max. 3 clients per search)</span> </h3>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type client name here. e.g., Michaelangelo A</mat-label>
                  <mat-chip-list #chipList1 aria-label="Topic selection">
                    <mat-chip *ngFor="let client of selectedClients" (removed)="removeClient(client)">
                      {{client}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip>

                    <input placeholder="" #clientInput [formControl]="clientValue" [matAutocomplete]="auto1"
                      [matChipInputFor]="chipList1" (matChipInputTokenEnd)="addClient($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="selectedClient($event)">
                    <mat-option *ngFor="let client of filteredClient | async" [value]="client" class="truncate">
                      {{client}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p class="error" *ngIf="isMaxClient">Only 3 clients can be selected.</p>
              </div>
            </div>
            <!-- Commenting out the Topic Autochip component, and should be uncommented by Features when in use. -->
            <div class="row section-divider "></div>
            <div class="row">
              <div class="col-md-12">

                <h3>Topic <span> (Max. 3 topics per search)</span> </h3>
                <mat-form-field appearance="fill" class="component-box chips">
                  <mat-label>Type topics here. e.g., Health related</mat-label>
                  <mat-chip-list #chipList2 aria-label="Topic selection">
                    <mat-chip *ngFor="let topic of selectedTopics" (removed)="removeTopic(topic)">
                      {{topic}}
                      <button matChipRemove>
                        <f-icon [iconConfig]="iconConfig"></f-icon>
                      </button>
                    </mat-chip>

                    <input placeholder="" #topicInput [formControl]="topicValue" [matAutocomplete]="auto2"
                      [matChipInputFor]="chipList2" (matChipInputTokenEnd)="addTopic($event)">
                  </mat-chip-list>
                  <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedTopic($event)">
                    <mat-option *ngFor="let topic of filteredTopic | async" [value]="topic" class="truncate">
                      {{topic}}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>

                <p class="error" *ngIf="isMaxTopics">Only 3 topics can be selected.</p>
              </div>
            </div>
            <div class="row section-divider"></div>
            <div class="row">
              <div class="col-md-12" id="">
                <h3>Channel</h3>
              </div>
            </div>
            <div class="row channel-list">
              <div class="col-md-12">
                <!-- <mat-checkbox class="">Call</mat-checkbox>
                <mat-checkbox class="">Chat</mat-checkbox>
                <mat-checkbox class="">Transfer</mat-checkbox>
                <mat-checkbox class="">Additional Account</mat-checkbox> -->
                <ng-container *ngFor="let channel of agentIHChannelList; ">
                  <mat-checkbox class="" #channelLists name="{{channel}}"
                    (change)="channelList($event, channel)">{{channel}}</mat-checkbox>
                </ng-container>
              </div>
            </div>
            <div class="row section-divider"></div>
          </div>
        </div>
      </form>
      <div class="button-controls">

        <f-button text="Clear all" type="button" variant="action" (click)="clearAll()"></f-button>
        <f-button text="Apply" type="button" variant="progressive"
          [disabled]="((!range.value.start || !range.value.end) && selectedChannels && selectedChannels.length == 0 && selectedClients && selectedClients.length == 0 &&  selectedTopics && selectedTopics.length == 0) || (range.invalid && range.dirty)"
          [ngClass]="{disableBtn:((!range.value.start || !range.value.end) && selectedChannels && selectedChannels.length == 0 && selectedClients && selectedClients.length == 0 && selectedTopics && selectedTopics.length == 0) || (range.invalid && range.dirty)}"
          (click)="apply()"></f-button>
      </div>



    </div>
  </div>
</app-customer-account-dialog>